import React, { FC, useState } from 'react';
import {
  BackgroundBox,
  EditorialContainer,
  CategoriesWrapper,
  CategoryColumn,
  ContentWrapper,
  ImageWrapper,
  Headline,
  ContentContainer,
} from './styles';
import { ContentfulCategoryEntry } from '../../lib/contentfulTypes';
import CategoryWrapper from '../CategoryWrapper';
import CategoryLink from '../CategoryLink';

interface EditorialCategoriesProps {
  fields: {
    headline: string;
    defaultMedia: {
      fields: {
        file: {
          url: string;
        };
        altText: string;
      };
    };
    backgroundImage?: {
      fields: {
        file: {
          url: string;
        };
      };
    };
    shopifyCollections: Array<ContentfulCategoryEntry>;
  };
}

const EditorialCategories: FC<EditorialCategoriesProps> = ({
  fields: { headline, defaultMedia, backgroundImage, shopifyCollections },
}) => {
  const defaultImageUrl = `https:${defaultMedia.fields.file.url}`;
  const backgroundImageUrl = backgroundImage ? `https:${backgroundImage.fields.file.url}` : null;
  const [currentImage, setCurrentImage] = useState(defaultImageUrl);

  const handleHover = (hoverImageUrl: string | undefined) => {
    setCurrentImage(hoverImageUrl || defaultImageUrl);
  };

  const renderCategories = (categories: ContentfulCategoryEntry[]) => {
    return categories.map((category, index) => (
      <CategoryWrapper
        key={`${category.fields.shopifyCollection || ''}-${index}`}
        category={category}
        Component={({ imageUrl, hoverImageUrl, ...rest }: { imageUrl: string; hoverImageUrl: string; [key: string]: any }) => (
          <CategoryLink
            title={''} url={''} {...rest}
            imageUrl={imageUrl}
            hoverImageUrl={hoverImageUrl}
            onHover={(hover: boolean) => handleHover(hover ? hoverImageUrl : undefined)}
          />
        )}
      />
    ));
  };  

  return (
    <ContentContainer>
      <BackgroundBox style={backgroundImageUrl ? { backgroundImage: `url(${backgroundImageUrl})` } : {}}>
      </BackgroundBox>
      <EditorialContainer>
        <Headline>{headline}</Headline>
        <ContentWrapper>
          <CategoriesWrapper>
            <CategoryColumn>
              {renderCategories(shopifyCollections.slice(0, 4))}
            </CategoryColumn>
            <ImageWrapper>
              <img
                src={currentImage}
                alt={defaultMedia.fields.altText}
                loading="lazy"
              />
            </ImageWrapper>
            <CategoryColumn>
              {renderCategories(shopifyCollections.slice(4, 8))}
            </CategoryColumn>
          </CategoriesWrapper>
        </ContentWrapper>
      </EditorialContainer>
    </ContentContainer>
  );
};

export default EditorialCategories;
